<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="1000px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t('View Statement Payable Information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <!-- %%%%%%%%%%%%%%%%% Print Section Title %%%%%%%%%%%%%%%%% -->
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">
                {{ $t('Account Payable Statements') }}
              </th>
            </tr>
          </table>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <table class="info-table" style="width: 100%">
                  <tr>
                    <td
                      align="end"
                      class="td-padding-bottom not-printable"
                      v-if="viewInfo.attachment !== null"
                      colspan="3"
                    >
                      <v-chip dark color="primary">
                        <v-avatar>
                          <v-icon>insert_drive_file</v-icon>
                        </v-avatar>
                        <a
                          :href="`${baseUrls.images}/${viewInfo.attachment}`"
                          target="_blank"
                          style="color: white; text-decoration: none"
                        >
                          {{ $t('Click to View Attachment') }}
                        </a>
                      </v-chip>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Supplier') }}</div>
                      <strong>{{ viewInfo.vender_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Code') }}</div>
                      <strong>{{ viewInfo.payable_statement_auto_number || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Date') }}</div>
                      <strong v-if="viewInfo.statement_date">{{ viewInfo.statement_date }}</strong>
                      <strong v-else>-</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ `${$t('Amount')} (${systemCurrency})` }}
                      </div>
                      <strong v-if="viewInfo.amount">{{ viewInfo.amount | currency }}</strong>
                      <strong v-else>-</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ `${$t('Balance')} (${systemCurrency})` }}
                      </div>
                      <strong v-if="viewInfo.balance">{{ viewInfo.balance | currency }}</strong>
                      <strong v-else>-</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ `${$t('Paid')} (${systemCurrency})` }}
                      </div>
                      <strong v-if="viewInfo.paid">{{ viewInfo.paid | currency }}</strong>
                      <strong v-else>-</strong>
                    </td>
                  </tr>
                </table>
              </v-layout>

              <v-layout row wrap justify-center mt-3 v-if="viewInfo.remittance_details">
                <table>
                  <tr>
                    <th class="section-title-content">
                      {{ $t('Remittance Details') }}
                    </th>
                  </tr>
                </table>

                <v-flex xs10>
                  <v-divider />
                </v-flex>
              </v-layout>

              <v-layout row wrap class="invoice-content" mt-4 v-if="viewInfo.remittance_details">
                <v-flex xs12 sm12>
                  <v-layout row wrap>
                    <table class="printed-table" cellspacing="0">
                      <thead>
                        <tr>
                          <th xs1 class="pa-2 view-table-header">#</th>
                          <th class="view-table-header" xs3 pa-2>
                            {{ $t('Remittance Office') }}
                          </th>
                          <th class="view-table-header" xs3 pa-2>
                            {{ $t('Date') }}
                          </th>
                          <th class="view-table-header" xs2 pa-2>
                            {{ `${$t('Commission')} (${systemCurrency})` }}
                          </th>
                          <th class="view-table-header" xs2 pa-2>
                            {{ `${$t('Amount')} (${systemCurrency})` }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in 1" :key="index">
                          <td class="view-table-row">
                            <p class="view-table-content">{{ index + 1 }}</p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ viewInfo.remittance_details.remittance_office_name }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ viewInfo.remittance_details.transaction_date }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ viewInfo.remittance_details.remittance_commission | currency }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ viewInfo.remittance_details.amount | currency }}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="only-for-print">
                          <td>
                            <div class="footer-space">&nbsp;</div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout row wrap justify-center mt-4 v-if="hasPurchaseDetail">
                <table>
                  <tr>
                    <th class="section-title-content">
                      {{ $t('Purchase Details') }}
                    </th>
                  </tr>
                </table>

                <v-flex xs10>
                  <v-divider />
                </v-flex>
              </v-layout>

              <v-layout row wrap class="invoice-content" mt-4 v-if="hasPurchaseDetail">
                <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
                  <v-layout row wrap>
                    <table class="info-table" style="width: 100%">
                      <tr>
                        <td class="td-padding-bottom">
                          <div class="caption no-select">
                            {{ $t('Supplier Invoice Number') }}
                          </div>
                          <strong>{{ purchaseDetail.supplier_invoice_number || '-' }}</strong>
                        </td>
                        <td class="td-padding-bottom">
                          <div class="caption no-select">
                            {{ $t('Supplier Name') }}
                          </div>
                          <strong>{{ purchaseDetail.vender_name || '-' }}</strong>
                        </td>
                        <td class="td-padding-bottom">
                          <div class="caption no-select">
                            {{ $t('Bill Date') }}
                          </div>
                          <strong v-if="purchaseDetail.bill_date">{{ purchaseDetail.bill_date }}</strong>
                          <strong v-else>-</strong>
                        </td>
                        <td class="td-padding-bottom">
                          <div class="caption no-select">
                            {{ $t('Payment Type') }}
                          </div>
                          <strong>{{ $t(purchaseDetail.cash_or_opening_balance) || '-' }}</strong>
                        </td>
                        <td
                          class="td-padding-bottom not-printable"
                          v-if="purchaseDetail.attachment !== null"
                          style="width: 1px; white-space: nowrap;"
                        >
                          <v-chip dark color="primary">
                            <v-avatar>
                              <v-icon>insert_drive_file</v-icon>
                            </v-avatar>
                            <a
                              :href="`${baseUrls.images}/${purchaseDetail.attachment}`"
                              target="_blank"
                              style="color: white; text-decoration: none"
                            >
                              {{ $t('Click to View Attachment') }}
                            </a>
                          </v-chip>
                        </td>
                      </tr>
                    </table>

                    <table class="printed-table" cellspacing="0">
                      <thead>
                        <tr class="only-for-print">
                          <td>
                            <div class="header-space">&nbsp;</div>
                          </td>
                        </tr>
                        <tr>
                          <th class="pa-2 view-table-header">#</th>
                          <th class="view-table-header" pa-2>
                            {{ $t('Product') }}
                          </th>
                          <th class="view-table-header" pa-2 v-if="settings.product_expiry === 'Active'">
                            {{ $t('Expiration Date') }}
                          </th>
                          <th class="view-table-header" pa-2>
                            {{ $t('Quantity') }}
                          </th>
                          <th class="view-table-header" pa-2>
                            {{ `${$t('Price')} (${systemCurrency})` }}
                          </th>
                          <th class="view-table-header" pa-2>
                            {{ `${$t('Total')} (${systemCurrency})` }}
                          </th>
                          <th class="view-table-header" pa-2 v-if="settings.purchase_tax === 'Active'">
                            {{ `${$t('Tax')} (${systemCurrency})` }}
                          </th>
                          <th class="view-table-header" pa-2>
                            {{ `${$t('Transport Cost')} (${systemCurrency})` }}
                          </th>
                          <th class="view-table-header" pa-2>
                            {{ `${$t('Item Cost')} (${systemCurrency})` }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in rowNumbers" :key="index">
                          <td class="view-table-row">
                            <p class="view-table-content">{{ index + 1 }}</p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ purchaseDetail.product_name[index] }}
                            </p>
                          </td>
                          <td class="view-table-row" v-if="settings.product_expiry === 'Active'">
                            <p class="view-table-content">
                              {{ purchaseDetail.expire_date[index] }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ purchaseDetail.purchase_quantity[index] | currency }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ purchaseDetail.purchase_price[index] | currency }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ purchaseDetail.total[index] | currency }}
                            </p>
                          </td>
                          <td class="view-table-row" v-if="settings.purchase_tax === 'Active'">
                            <p class="view-table-content">
                              {{ purchaseDetail.purchase_tax[index] | currency }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ purchaseDetail.purchase_transport[index] | currency }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ itemCost(index) | currency }}
                            </p>
                          </td>
                        </tr>
                        <tr class="last-table-row-for-currency">
                          <td class="last-table-row" :colspan="getColSpan()">
                            <p class="view-table-content">
                              {{ `${$t('Total Amount')} (${systemCurrency})` }}
                            </p>
                          </td>
                          <td class="last-table-row2">
                            <p class="view-table-content">
                              {{ purchaseDetail.total_amount | currency }}
                            </p>
                          </td>
                        </tr>
                        <tr class="last-table-row-for-currency">
                          <td class="last-table-row" :colspan="getColSpan()">
                            <p class="view-table-content">
                              {{ `${$t('Transport Cost')} (${systemCurrency})` }}
                            </p>
                          </td>
                          <td class="last-table-row2">
                            <p class="view-table-content">
                              {{ purchaseDetail.transport_cost | currency }}
                            </p>
                          </td>
                        </tr>
                        <tr class="last-table-row-for-currency">
                          <td class="last-table-row" :colspan="getColSpan()">
                            <p class="view-table-content">
                              {{ `${$t('Other Cost')} (${systemCurrency})` }}
                            </p>
                          </td>
                          <td class="last-table-row2">
                            <p class="view-table-content">
                              {{ purchaseDetail.other_cost | currency }}
                            </p>
                          </td>
                        </tr>
                        <tr class="last-table-row-for-currency">
                          <td class="last-table-row" :colspan="getColSpan()">
                            <p class="view-table-content">
                              {{ `${$t('Grand Total Tax')} (${systemCurrency})` }}
                            </p>
                          </td>
                          <td class="last-table-row2">
                            <p class="view-table-content">
                              {{ purchaseDetail.tax | currency }}
                            </p>
                          </td>
                        </tr>
                        <tr class="last-table-row-for-currency">
                          <td class="last-table-row" :colspan="getColSpan()">
                            <p class="view-table-content">
                              {{ `${$t('Grand Total Amount')} (${systemCurrency})` }}
                            </p>
                          </td>
                          <td class="last-table-row2">
                            <p class="view-table-content">
                              {{ purchaseDetail.grand_total_amount | currency }}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="only-for-print">
                          <td>
                            <div style="height: 50px">&nbsp;</div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout row wrap justify-center mt-4 v-if="hasExpenseDetail">
                <table>
                  <tr>
                    <th class="section-title-content">
                      {{ $t('Expense Details') }}
                    </th>
                  </tr>
                </table>

                <v-flex xs10>
                  <v-divider />
                </v-flex>
              </v-layout>

              <v-layout row wrap mt-4 v-if="hasExpenseDetail">
                <table class="info-table" style="width: 100%">
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Expense Type') }}</div>
                      <strong>{{ expenseDetail.expense_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Outlet') }}</div>
                      <strong>{{ expenseDetail.outlet_name || '-' }}</strong>
                    </td>
                    <td
                      class="td-padding-bottom not-printable"
                      v-if="expenseDetail.attachment !== null"
                      style="width: 1px; white-space: nowrap;"
                    >
                      <v-chip dark color="primary">
                        <v-avatar>
                          <v-icon>insert_drive_file</v-icon>
                        </v-avatar>
                        <a
                          :href="`${baseUrls.images}/${expenseDetail.attachment}`"
                          target="_blank"
                          style="color: white; text-decoration: none"
                        >
                          {{ $t('Click to View Attachment') }}
                        </a>
                      </v-chip>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ `${$t('Amount')} (${systemCurrency})` }}</div>
                      <strong v-if="expenseDetail.amount">{{ expenseDetail.amount | currency }}</strong>
                      <strong v-else>-</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Payment Type') }}</div>
                      <strong v-if="expenseDetail.payment_type">{{ expenseDetail.payment_type }}</strong>
                      <strong v-else>-</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Payment Date') }}</div>
                      <strong v-if="expenseDetail.payment_date">{{ expenseDetail.payment_date }}</strong>
                      <strong v-else>-</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Supplier') }}</div>
                      <strong>{{ expenseDetail.vender_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Payment Recipient') }}</div>
                      <strong>{{ expenseDetail.payment_recipient || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Voucher Number') }}</div>
                      <strong>{{ expenseDetail.voucher_number || '-' }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom" colspan="3">
                      <div class="caption no-select">{{ $t('Notes') }}</div>
                      <strong v-html="lnToBr(expenseDetail.note) || '-'" />
                    </td>
                  </tr>
                </table>
              </v-layout>

              <v-layout row wrap justify-center mt-3 v-if="paymentNumbers > 0">
                <table>
                  <tr>
                    <th class="section-title-content">
                      {{ $t('Payment Details') }}
                    </th>
                  </tr>
                </table>

                <v-flex xs10>
                  <v-divider />
                </v-flex>
              </v-layout>

              <v-layout row wrap class="invoice-content" mt-4 v-if="paymentNumbers > 0">
                <v-flex xs12 sm12>
                  <v-layout row wrap>
                    <table class="printed-table" cellspacing="0">
                      <thead>
                        <tr>
                          <th xs1 class="pa-2 view-table-header">#</th>
                          <th class="view-table-header" xs3 pa-2>
                            {{ $t('Recipient Name') }}
                          </th>
                          <th class="view-table-header" xs3 pa-2>
                            {{ $t('Date') }}
                          </th>
                          <th class="view-table-header" xs2 pa-2>
                            {{ `${$t('Amount')} (${systemCurrency})` }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in paymentNumbers" :key="index">
                          <td class="view-table-row">
                            <p class="view-table-content">{{ index + 1 }}</p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ paymentDetail.recipient_name[index] }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ paymentDetail.date[index] }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ paymentDetail.amount[index] | currency }}
                            </p>
                          </td>
                        </tr>
                        <tr class="last-table-row-for-currency">
                          <td class="view-table-row" colspan="3">
                            <p class="view-table-content">
                              {{ `${$t('Total Paid')}` }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ paymentDetail.total_paid | currency }}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="only-for-print">
                          <td>
                            <div class="footer-space">&nbsp;</div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </v-layout>
                </v-flex>
              </v-layout>

              <invoice-footer
                :showSignatureSection="false"
                :accountantName="''"
                :payerRecipientName="''"
                :payerOrRecipient="''"
                class="only-for-print"
              />
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      rowNumbers: 0,
      hasPurchaseDetail: false,
      purchaseDetail: {
        purchase_id: 0,
        supplier_invoice_number: '',
        attachment: '',
        vender_name: '',
        bill_date: '',
        cash_or_opening_balance: '',
        total_amount: '',
        transport_cost: 0,
        other_cost: 0,
        tax: 0,
        grand_total_amount: 0,
        product_name: [],
        purchase_quantity: [],
        purchase_price: [],
        purchase_tax: [],
        total_tax: [],
        purchase_transport: [],
        total_transport: [],
        expire_date: [],
        total: []
      },
      hasPaymentDetail: false,
      paymentNumbers: 0,
      paymentDetail: {
        total_paid: 0,
        recipient_name: [],
        date: [],
        amount: []
      },
      hasExpenseDetail: false,
      expenseDetail: {
        expense_name: '',
        outlet_name: '',
        attachment: null,
        amount: 0,
        payment_type: '',
        payment_date: '',
        vender_name: '',
        payment_recipient: '',
        voucher_number: '',
        note: ''
      }
    }
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.hasPurchaseDetail = this.viewInfo.detail && this.viewInfo.detail.data_detail
          if (this.hasPurchaseDetail) {
            this.rowNumbers = this.viewInfo.detail.data_detail.length
            this.purchaseDetail.supplier_invoice_number = this.viewInfo.detail.data.supplier_invoice_number
            this.purchaseDetail.vender_name = this.viewInfo.detail.data.vender_name
            this.purchaseDetail.bill_date = this.viewInfo.detail.data.bill_date
            this.purchaseDetail.cash_or_opening_balance = this.viewInfo.detail.data.cash_or_opening_balance

            this.purchaseDetail.total_amount = this.viewInfo.detail.data.total_amount
            this.purchaseDetail.transport_cost = this.viewInfo.detail.data.transfer_cost
            this.purchaseDetail.other_cost = this.viewInfo.detail.data.other_cost
            this.purchaseDetail.tax = this.viewInfo.detail.data.tax
            this.purchaseDetail.grand_total_amount = this.viewInfo.detail.data.grand_total_amount
            this.purchaseDetail.attachment = this.viewInfo.detail.data.attachment
            this.purchaseDetail.purchase_id = this.viewInfo.detail.data.purchase_id

            this.purchaseDetail.product_name = []
            this.purchaseDetail.purchase_quantity = []
            this.purchaseDetail.purchase_price = []
            this.purchaseDetail.purchase_tax = []
            this.purchaseDetail.total_tax = []
            this.purchaseDetail.purchase_transport = []
            this.purchaseDetail.total_transport = []
            this.purchaseDetail.expire_date = []
            this.purchaseDetail.total = []

            this.viewInfo.detail.data_detail.forEach(c => {
              this.purchaseDetail.product_name.push(c.product_name)
              this.purchaseDetail.purchase_quantity.push(c.purchase_quantity)
              this.purchaseDetail.purchase_price.push(c.purchase_price)
              this.purchaseDetail.purchase_tax.push(c.purchase_tax)
              this.purchaseDetail.purchase_transport.push(c.purchase_transfer)
              this.purchaseDetail.total_transport.push(c.total_transfer)
              this.purchaseDetail.total_tax.push(c.total_tax)
              this.purchaseDetail.total.push(c.total)
              this.purchaseDetail.expire_date.push(c.expire_date)
            })
          }

          this.hasExpenseDetail = this.viewInfo.detail && this.viewInfo.detail.expense_id
          if (this.hasExpenseDetail) {
            this.expenseDetail.expense_name = this.viewInfo.detail.expense_name
            this.expenseDetail.outlet_name = this.viewInfo.detail.outlet_name
            this.expenseDetail.attachment = this.viewInfo.detail.attachment
            this.expenseDetail.amount = this.viewInfo.detail.amount
            this.expenseDetail.payment_type = this.viewInfo.detail.payment_type
            this.expenseDetail.payment_date = this.viewInfo.detail.payment_date
            this.expenseDetail.vender_name = this.viewInfo.detail.vender_name
            this.expenseDetail.payment_recipient = this.viewInfo.detail.payment_recipient
            this.expenseDetail.voucher_number = this.viewInfo.detail.voucher_number
            this.expenseDetail.note = this.viewInfo.detail.note
          }

          this.hasPaymentDetail = this.viewInfo.payment_detail !== null
          if (this.hasPaymentDetail) {
            this.paymentNumbers = this.viewInfo.payment_detail.length
            this.paymentDetail.total_paid = this.viewInfo.paid
            this.viewInfo.payment_detail.forEach(c => {
              this.paymentDetail.recipient_name.push(c.recipient_name)
              this.paymentDetail.date.push(c.payment_date)
              this.paymentDetail.amount.push(c.amount)
            })
          }
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      viewInfo: 'accountStatements/getStatementInfo',
      settings: 'configurations/getSystemSettings'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },
    itemCost(index) {
      return (
        this.purchaseDetail.purchase_price[index] +
        this.purchaseDetail.purchase_tax[index] +
        this.purchaseDetail.purchase_transport[index]
      )
    },
    getColSpan() {
      if (this.settings.product_expiry === 'Active' && this.settings.purchase_tax === 'Active') {
        return 8
      } else if (this.settings.product_expiry === 'Active' || this.settings.purchase_tax === 'Active') {
        return 7
      } else {
        return 6
      }
    },
    printMe() {
      // we pass true parameter to the function
      // in this way we know that we print invoice and some other style should apply
      // if we don't pass anything it will be false which means
      // we don't print invoice and other styles won't be applied
      // helpers.doPrinting(this.hasPurchaseDetail)

      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      let infoTable = document.querySelector('.info-table')
      theDialogContent.classList.remove('grey')
      infoTable.classList.add('add-padding-for-info-table')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })
      document.querySelector('.printed-table').style.marginTop = '-120px'

      this.$htmlToPaper('printArea', () => {
        infoTable.classList.remove('add-padding-for-info-table')
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
        document.querySelector('.printed-table').style.marginTop = '0px'
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
